import { DeveloperPageLayout } from '@/components/developer/shared/DeveloperPageLayout';
import { APIConfiguration } from '@/components/developer/sections/APIConfiguration';
import { APIStatusDashboard } from '@/components/developer/sections/APIStatusDashboard';
import { WebhookConfiguration } from '@/components/developer/sections/WebhookConfiguration';
import { IntegrationsConfig } from '@/components/developer/sections/IntegrationsConfig';
import { DeveloperTools } from '@/components/developer/sections/DeveloperTools';
import { ExperimentalFeatures } from '@/components/developer/sections/ExperimentalFeatures';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export function DeveloperSettings() {
  return (
    <DeveloperPageLayout
      title="Developer Settings"
      subtitle="Configuración avanzada y herramientas"
    >
      <Tabs defaultValue="api" className="space-y-6">
        <TabsList>
          <TabsTrigger value="api">API & Keys</TabsTrigger>
          <TabsTrigger value="status">API Status</TabsTrigger>
          <TabsTrigger value="webhooks">Webhooks</TabsTrigger>
          <TabsTrigger value="integrations">Integrations</TabsTrigger>
          <TabsTrigger value="tools">Dev Tools</TabsTrigger>
          <TabsTrigger value="experimental">Experimental</TabsTrigger>
        </TabsList>
        
        <TabsContent value="api">
          <APIConfiguration />
        </TabsContent>
        
        <TabsContent value="status">
          <APIStatusDashboard />
        </TabsContent>
        
        <TabsContent value="webhooks">
          <WebhookConfiguration />
        </TabsContent>
        
        <TabsContent value="integrations">
          <IntegrationsConfig />
        </TabsContent>
        
        <TabsContent value="tools">
          <DeveloperTools />
        </TabsContent>
        
        <TabsContent value="experimental">
          <ExperimentalFeatures />
        </TabsContent>
      </Tabs>
    </DeveloperPageLayout>
  );
}